import { render } from "./TagsManagementModal.vue?vue&type=template&id=76b7247e&scoped=true&ts=true"
import script from "./TagsManagementModal.vue?vue&type=script&lang=ts"
export * from "./TagsManagementModal.vue?vue&type=script&lang=ts"

import "./TagsManagementModal.vue?vue&type=style&index=0&id=76b7247e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b7247e"]])

export default __exports__